const ErrorText = ({ text }) =>
    <div className="flex align-center" style={{ height: '18px' }}>
        <p style={{ color: 'red', marginTop: '1px', marginLeft: '3px', fontSize: '10px', fontWeight:'bolder' }}>{text}</p>
    </div>

export default ErrorText